import React from "react";
import FiltersBar from "./FiltersBar";

export default function Toolbar({ 
  filters, 
  setFilters, 
  loading, 
  onRefresh, 
  onClearFilters 
}) {
  return (
    <div className="toolbar">
      <div>
        <div className="title">Admin Dashboard</div>
        <div className="subtitle">Manage and approve leads</div>
      </div>
      <FiltersBar
        filters={filters}
        setFilters={setFilters}
        loading={loading}
        onRefresh={onRefresh}
        onClearFilters={onClearFilters}
      />
    </div>
  );
}

